export const collaborationSetup = {
  junior: {
    workflows: [
      { name: 'Design Process Integration', description: 'Collaborate with product and engineering teams throughout design process', frequency: 'Daily design collaboration' },
      { name: 'User Research Collaboration', description: 'Work with UX researchers to inform design decisions', process: 'Research synthesis and design application' },
      { name: 'Design Review Process', description: 'Participate in design critiques and feedback sessions', deliverable: 'Iterative design improvements' }
    ],
    tools: [
      { name: 'Slack', purpose: 'Design team communication and updates', channels: ['#product-design', '#design-team', '#product-team'] },
      { name: 'Figma', purpose: 'Collaborative design and prototyping', access: 'Editor permissions for design files' },
      { name: 'Miro', purpose: 'Design thinking and ideation sessions', permissions: 'Board creation and collaboration' }
    ],
    processes: [
      { name: 'Design Brief Process', steps: ['Receive design brief', 'Understand user needs', 'Create design concepts', 'Iterate based on feedback', 'Deliver final designs'] },
      { name: 'Design Handoff', steps: ['Prepare design specifications', 'Document design decisions', 'Collaborate with engineers', 'Support implementation'] }
    ]
  },
  mid: {
    workflows: [
      { name: 'Product Strategy Collaboration', description: 'Contribute to product strategy and roadmap planning', responsibility: 'Design strategy input and validation' },
      { name: 'Cross-functional Leadership', description: 'Lead design initiatives across multiple teams', scope: 'Multi-team design coordination' },
      { name: 'Design System Contribution', description: 'Contribute to and maintain design system components', commitment: 'System consistency and evolution' }
    ],
    tools: [
      { name: 'Abstract', purpose: 'Design version control and collaboration', access: 'Project lead permissions' },
      { name: 'Zeplin', purpose: 'Design handoff and developer collaboration', permissions: 'Project creation and management' },
      { name: 'Amplitude', purpose: 'Product analytics and design impact measurement', access: 'Analytics dashboard access' }
    ],
    processes: [
      { name: 'Design Strategy Development', steps: ['Analyze user needs', 'Define design strategy', 'Align with product goals', 'Execute strategic design initiatives'] },
      { name: 'Cross-team Design Leadership', steps: ['Facilitate design workshops', 'Coordinate design efforts', 'Ensure design consistency', 'Mentor junior designers'] }
    ]
  },
  senior: {
    workflows: [
      { name: 'Design Leadership', description: 'Lead design vision and strategy across organization', responsibility: 'Design program leadership and culture development' },
      { name: 'Product Innovation', description: 'Drive product innovation through design thinking and strategy', scope: 'Company-wide design influence' },
      { name: 'Design Operations', description: 'Establish and optimize design operations and processes', impact: 'Design team efficiency and effectiveness' }
    ],
    tools: [
      { name: 'Design Operations Platform', purpose: 'Enterprise design management and optimization', role: 'Platform administrator and strategist' },
      { name: 'Advanced Analytics Suite', purpose: 'Design impact measurement and business intelligence', access: 'Full analytics platform access' },
      { name: 'Design System Platform', purpose: 'Enterprise design system management', role: 'System architecture and governance lead' }
    ],
    processes: [
      { name: 'Design Vision Strategy', steps: ['Define design vision', 'Build design capabilities', 'Measure design impact', 'Scale design practices'] },
      { name: 'Design Culture Development', steps: ['Evangelize design value', 'Build design-driven culture', 'Develop design talent', 'Drive organizational design maturity'] }
    ]
  }
};
